import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "../customAxios.js";

export function useAdminDetail() {
  const { adminId } = useParams();
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAdmin = useCallback(async () => {
    if (!adminId) return;
    setLoading(true);
    setError(null);
    try {
      const { data } = await axios.get(`admins/staff/${adminId}/`);
      setAdmin(data);
    } catch (err) {
      console.error(`Error al obtener datos del admin: ${err}`);
      setError("No se pudieron obtener los datos del admin.");
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  }, [adminId]);

  const updateAdminPlan = useCallback(async (field, key, value) => {
    try {
      const { data } = await axios.patch(`admins/staff/${adminId}/plan/`, {
        [field]: { [key]: value },
      });
      setAdmin((prev) => ({ ...prev, admin_plan: data }));
    } catch (err) {
      console.error(`Error al actualizar el plan del admin: ${err}`);
      throw err;
    }
  }, [adminId]);

  useEffect(() => {
    fetchAdmin();
  }, [fetchAdmin]);

  return { admin, loading, error, updateAdminPlan };
}
